<div *ngIf="activeCaption" class="breadcrumbs">
    <div *ngIf="level0Caption" class="breadcrumb-item"><a href="{{level0Route}}">{{level0Caption}}</a></div>
    <div *ngIf="level1Caption && level1Route" class="breadcrumb-item"><a href="{{level1Route}}">{{level1Caption}}</a></div>
    <div *ngIf="level2Caption && level2Route" class="breadcrumb-item"><a href="{{level2Route}}">{{level2Caption}}</a></div>
    <div *ngIf="level3Caption && level3Route" class="breadcrumb-item"><a href="{{level3Route}}">{{level3Caption}}</a></div>
    <div class="breadcrumb-item active" aria-current="page">{{activeCaption}}</div>
</div>
